/*
 * Delivery option toggle for the cart drawer and cart page.
 *
 *   instant -> "Delivery within 2 hours": the AJ / ODDM delivery-date widget is removed and any delivery-date cart
 *              attributes it wrote are cleared, so the order carries no scheduled date.
 *   custom  -> "Custom date & time": the widget is (re)injected and a date is required before checkout.
 *
 * The choice is kept in localStorage under "delivery_type" (same key as the previous theme) and mirrored on
 * <html data-delivery-type> so CSS can style it before this script runs. Vanilla JS on purpose: the theme does not
 * load jQuery, the ODDM widget brings its own.
 */
(function () {
  if (window.__deliveryTypeSwitch) return;
  window.__deliveryTypeSwitch = true;

  var STORAGE_KEY = 'delivery_type';
  var DEFAULT_TYPE = 'instant';
  var WIDGET_BOX = '.appjetty-ddm-cart-box';
  // Attributes written by the ODDM widget that describe a scheduled delivery.
  var DATE_ATTRIBUTES = ['DDM Delivery Type', 'No-contact Delivery', 'Delivery Date', 'Delivery Time', 'Delivery Day'];
  var DATE_COOKIES = ['oddm_shipping_date', 'oddm_shipping_time', 'oddm_shipping_comment'];

  var root = document.documentElement;
  var current = readType();

  function instantUnavailable() {
    var config = window.deliveryInstantConfig || {};
    try {
      var day = new Date().getDay();
      if (config.timeZone) {
        day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(
          new Intl.DateTimeFormat('en-US', { weekday: 'short', timeZone: config.timeZone }).format(new Date())
        );
      }
      return (config.offDays || []).indexOf(day) !== -1;
    } catch (e) {
      return false; // bad time zone / old browser: leave the option available
    }
  }

  function readType() {
    if (instantUnavailable()) return 'custom';
    try {
      var value = window.localStorage.getItem(STORAGE_KEY);
      return value === 'custom' || value === 'instant' ? value : DEFAULT_TYPE;
    } catch (e) {
      return DEFAULT_TYPE;
    }
  }

  function saveType(type) {
    try { window.localStorage.setItem(STORAGE_KEY, type); } catch (e) { /* storage blocked: keep in-memory state */ }
  }

  function rootUrl(path) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return base + path;
  }

  function isCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  // ---------------------------------------------------------------- UI sync

  function syncSwitches() {
    var unavailable = instantUnavailable();
    root.setAttribute('data-delivery-type', current);
    root.setAttribute('data-instant-unavailable', unavailable ? 'true' : 'false');
    document.querySelectorAll('[data-delivery-type-input]').forEach(function (input) {
      input.checked = input.value === current;
      if (input.value === 'instant') input.disabled = unavailable;
    });
    document.querySelectorAll('[data-delivery-notice]').forEach(function (notice) {
      notice.hidden = current !== 'instant';
    });
    document.querySelectorAll('[data-delivery-unavailable]').forEach(function (notice) {
      notice.hidden = !unavailable;
    });
  }

  function clearErrors() {
    document.querySelectorAll('[data-delivery-error]').forEach(function (el) {
      el.hidden = true;
      el.textContent = '';
    });
    document.querySelectorAll('#dds_calendar').forEach(function (el) { el.style.borderColor = ''; });
  }

  // ------------------------------------------------------- ODDM widget glue

  function removeWidget() {
    document.querySelectorAll(WIDGET_BOX).forEach(function (box) { box.remove(); });
  }

  // The app injects next to the FIRST [name="checkout"] it finds, and the drawer comes before <main> in the DOM, so on
  // /cart the calendar lands inside the hidden drawer. Move it next to the cart page's own checkout button, and drop
  // any duplicate so there is a single #dds_calendar. Moving (not cloning) keeps the widget's bindings intact.
  function placeWidget() {
    if (!isCartPage()) return;
    var boxes = document.querySelectorAll(WIDGET_BOX);
    if (!boxes.length) return;
    var outside = null;
    boxes.forEach(function (box) { if (!box.closest('cart-drawer')) outside = outside || box; });
    if (outside) {
      boxes.forEach(function (box) { if (box !== outside) box.remove(); });
      return;
    }
    var pageButton = document.querySelector('main form [name="checkout"]');
    if (!pageButton) return;
    pageButton.parentNode.insertBefore(boxes[0], pageButton);
    for (var i = 1; i < boxes.length; i++) boxes[i].remove();
  }

  function injectWidget() {
    if (document.querySelector(WIDGET_BOX)) return;
    try {
      if (typeof window.ddmLoadHtml !== 'function' || typeof window.DDM_Calendar_view === 'undefined') return;
      window.ddmLoadHtml();
      if (!document.querySelector(WIDGET_BOX)) return;
      placeWidget();
      window.DDM_Calendar_view.init();
    } catch (e) {
      if (window.console) console.warn('[delivery-type-switch] could not inject the delivery-date widget', e);
    }
  }

  function expireCookie(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
  }

  function clearScheduledDelivery() {
    DATE_COOKIES.forEach(expireCookie);
    return fetch(rootUrl('cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var stale = {};
        var found = false;
        DATE_ATTRIBUTES.forEach(function (name) {
          if (cart.attributes && cart.attributes[name]) {
            stale[name] = '';
            found = true;
          }
        });
        if (!found) return;
        return fetch(rootUrl('cart/update.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: stale })
        });
      })
      .catch(function () { /* network hiccup: the next apply() retries */ });
  }

  function clearWidgetSelection() {
    var calendar = document.getElementById('dds_calendar');
    if (calendar) calendar.value = '';
    var slots = document.querySelector('.ddm_select_box.slot-listing');
    if (slots) slots.style.display = 'none';
  }

  // Custom delivery is a scheduled shipping order. The old theme always wrote these two attributes when "Custom date &
  // time" was chosen and the widget does not reliably do it, so make sure they exist -- but never overwrite a value that
  // is already there (e.g. the widget's no-contact checkbox set to "Yes").
  var CUSTOM_DEFAULTS = { 'DDM Delivery Type': 'Shipping', 'No-contact Delivery': 'No' };

  function ensureCustomAttributes() {
    if (current !== 'custom') return;
    fetch(rootUrl('cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (current !== 'custom') return;
        var missing = {};
        var found = false;
        Object.keys(CUSTOM_DEFAULTS).forEach(function (name) {
          if (!cart.attributes || !cart.attributes[name]) {
            missing[name] = CUSTOM_DEFAULTS[name];
            found = true;
          }
        });
        if (!found) return;
        return fetch(rootUrl('cart/update.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: missing })
        });
      })
      .catch(function () { /* network hiccup: the next trigger retries */ });
  }

  // In custom mode the live AJ widget disables every checkout button until a date is chosen. Instant delivery has no
  // date, so switching to it (or loading in it) must hand the buttons back, exactly as the old theme did.
  function enableCheckout() {
    document.querySelectorAll('[name="checkout"]').forEach(function (button) { button.removeAttribute('disabled'); });
  }

  // ------------------------------------------------------------ apply state

  function apply(options) {
    options = options || {};
    syncSwitches();
    clearErrors();

    if (current === 'instant') {
      removeWidget();
      enableCheckout();
      window.setTimeout(enableCheckout, 400); // the app may re-apply its disabled state right after we remove it
      if (options.clearAttributes !== false) clearScheduledDelivery();
    } else {
      // On page load / drawer refresh the app (and theme.liquid's refresh hook) place the widget themselves;
      // only re-inject when the customer switches back from instant, since we removed it.
      if (options.userChange) {
        injectWidget();
        clearWidgetSelection();
      }
      // Let the widget finish its own attribute writes first, then fill in whatever it left out.
      window.setTimeout(ensureCustomAttributes, 800);
    }
  }

  function setType(type) {
    if (type === current || (type === 'instant' && instantUnavailable())) return;
    current = type;
    saveType(type);
    apply({ userChange: true });
  }

  // ------------------------------------------------------- checkout gating

  function selectedDate(scope) {
    var field = (scope && scope.querySelector && scope.querySelector('#dds_calendar')) || document.getElementById('dds_calendar');
    if (!field) return null; // widget absent (not loaded / not applicable): never trap the customer
    var box = field.closest(WIDGET_BOX) || field;
    if (!box.getClientRects().length) return null; // widget hidden by its own rules
    return field;
  }

  function showDateRequired(scope, field) {
    var target = scope && scope.querySelector ? scope.querySelector('[data-delivery-error]') : null;
    target = target || document.querySelector('[data-delivery-error]');
    if (target) {
      target.textContent = (typeof window.error_msg === 'string' && window.error_msg) || target.getAttribute('data-default-message');
      target.hidden = false;
    }
    field.style.borderColor = (typeof window.error_msg_color === 'string' && window.error_msg_color) || '';
    field.scrollIntoView({ behavior: 'smooth', block: 'center' });
    try { field.focus({ preventScroll: true }); } catch (e) { /* not focusable */ }
  }

  // What the customer is looking at in the widget: the date text and, if shown, the chosen time slot.
  function visibleSelection(field, scope) {
    var slot = (scope && scope.querySelector && scope.querySelector('.slot-time-list')) || document.querySelector('.slot-time-list');
    var time = slot && slot.getClientRects().length ? slot.value : '';
    return { date: field.value, time: time };
  }

  // The order carries the cart attributes, not the text in the box. They can drift apart (the theme refills the box
  // from a saved cookie after a drawer refresh, and the cart can be changed from another tab), so just before checkout
  // write exactly what is displayed to the cart. Resolves either way: a failed sync must never block checkout.
  function syncCartToSelection(selection) {
    return fetch(rootUrl('cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var attrs = cart.attributes || {};
        var update = {};
        if (attrs['Delivery Date'] !== selection.date) update['Delivery Date'] = selection.date;
        if (selection.time && attrs['Delivery Time'] !== selection.time) update['Delivery Time'] = selection.time;
        Object.keys(CUSTOM_DEFAULTS).forEach(function (name) {
          if (!attrs[name]) update[name] = CUSTOM_DEFAULTS[name];
        });
        if (!Object.keys(update).length) return;
        return fetch(rootUrl('cart/update.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: update })
        });
      })
      .catch(function () { /* fail open */ });
  }

  var syncing = false;
  var verifiedAt = 0;
  var VERIFIED_WINDOW_MS = 5000; // the theme re-dispatches the click itself, so let the replayed click straight through

  function guardCheckout(event, button) {
    if (current !== 'custom' || Date.now() - verifiedAt < VERIFIED_WINDOW_MS) return;
    var form = button.form || button.closest('form');
    var field = selectedDate(form);
    if (!field) return;

    if (!field.value) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showDateRequired(form, field);
      return;
    }

    // A date is chosen: hold the checkout, make the cart match the box, then replay it.
    event.preventDefault();
    event.stopImmediatePropagation();
    if (syncing) return;
    syncing = true;
    var isSubmit = event.type === 'submit';
    syncCartToSelection(visibleSelection(field, form)).then(function () {
      syncing = false;
      verifiedAt = Date.now();
      if (isSubmit && form.requestSubmit) form.requestSubmit(button);
      else button.click();
    });
  }

  // Window + capture so this runs before the widget's own document-level validation (no duplicate messages).
  window.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[name="checkout"]');
    if (button) guardCheckout(event, button);
  }, true);

  window.addEventListener('submit', function (event) {
    var form = event.target;
    var submitter = event.submitter;
    var button = submitter && submitter.name === 'checkout' ? submitter : (!submitter && form.querySelector && form.querySelector('[name="checkout"]'));
    if (button) guardCheckout(event, button);
  }, true);

  // Picking a date clears any error we showed.
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target) return;
    if (target.id === 'dds_calendar') clearErrors();
    if (target.id === 'dds_calendar' || (target.classList && target.classList.contains('slot-time-list'))) verifiedAt = 0;
    // The widget writes Delivery Date / Time here; top up the type + no-contact attributes right after it.
    if (target.id === 'dds_calendar' || (target.classList && target.classList.contains('slot-time-list'))) {
      window.setTimeout(ensureCustomAttributes, 700);
    }
  });

  // --------------------------------------------------------------- wiring

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (input && input.matches && input.matches('[data-delivery-type-input]')) setType(input.value);
  });

  // The drawer re-renders its footer after every cart change, resetting our markup and wiping the widget.
  document.addEventListener('cart-drawer:refreshed', function () {
    apply({ clearAttributes: false });
  });

  // instant: drop the widget whenever the app (re)injects it, so its "date required" check (which keys off
  // #dds_calendar being present) can never block an instant-delivery checkout.
  // custom: on /cart, make sure an app-injected widget ends up on the page rather than in the hidden drawer.
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    // A timer, not requestAnimationFrame: rAF is paused in background tabs, which would leave the widget misplaced.
    window.setTimeout(function () {
      scheduled = false;
      if (current === 'instant') removeWidget();
      else placeWidget();
    }, 30);
  }).observe(document.documentElement, { childList: true, subtree: true });

  function init() {
    apply();
    // The widget can write its own attributes shortly after load; re-check once it has settled.
    window.setTimeout(function () {
      if (current === 'instant') {
        enableCheckout();
        clearScheduledDelivery();
      } else {
        ensureCustomAttributes();
      }
    }, 1500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) { current = readType(); apply({ clearAttributes: false }); }
  });
})();
